<template>
    <div class="c-app flex-row align-items-center">
      <CContainer style="display: flex; justify-content: center" class="p-0">
        <div class="container-box center">
          <div class="text-left">
            <!-- {{ today }} -->
  
            <!-- kalau ada kelas -->
            <CCard 
              style="
                bottom: 0;
                max-width: 100%;
                left: 0;
                bottom: 0;
                right: 0;
                background: #e8f4ff;
                height: 900px;
                border-radius: 0px;
              "
            >
              <CRow class="row-timetable " 
                v-for="item in classes"
                v-bind:key="item.Id"
              >
                <div style="width: 15%">
                  <label class="badge-label-subject mb-0 mt-0"> {{ item.start | moment("MMM") }} </label> <br />
                  <label class="date-timetable mb-0 mt-0"> {{ item.start | moment("DD") }} </label> <br />
                  <label class="badge-label-subject mb-0 mt-0"> {{ item.start | moment("YYYY") }} </label>
                </div>
  
                <div style="width: 85%">
                  <CCard style="background: #0058aa; margin-bottom: 5px" @click="OpenDetail(item.id)">
                    <div class="card-upcoming-class m-3 text-white" style="gap: 4px">
                      {{ item.subjectName }}   with
                      <span class="custom-user-subtitle" style="color: #ffffff; margin-bottom: 0rem;display:contents"  v-for="name in item.student" v-bind:key="name.id">
  
                        <!-- <label class="custom-user-subtitle" style="color: #ffffff; margin-bottom: 0rem"  v-for="names in name.student.slice(0,1)" v-bind:key="name.id">  {{ item.subjectName }}</label> -->
                      {{ name.studentName }} ,
                      </span>
                      <br />
                      <label class="custom-user-subtitle" style="color: #ffffff; margin-bottom: 0rem">{{ item.start | moment("hh:mm A") }} -
                        {{ item.end | moment("hh:mm A") }}
                      </label>
                    </div>
                    <img src="../../assets/img/icon/chevron-right-white.svg" style="position: absolute; inset: 40% 90%"/>
                  </CCard>
                </div>
              </CRow>
              <br />
            </CCard>
  
            <!-- kalau takda kelas -->
            <!-- <CCard v-else
              style="bottom: 0;
                max-width: 100%;
                left: 0;
                bottom: 0;
                right: 0;
                background: #e8f4ff;
                height: 900px;
                border-radius: 0px;
              "
            > 
              <CRow class="row-timetable">
                <div style="width: 15%">
                  <label class="badge-label-subject mb-0 mt-0"> {{ today | moment("MMM") }} </label> <br />
                  <label class="date-timetable mb-0 mt-0"> {{ today | moment("DD") }} </label> <br />
                  <label class="badge-label-subject mb-0 mt-0"> {{ today | moment("YYYY") }} </label>
                </div>
  
                <div style="width: 85%">
                  <CCard style="background: #0058aa; margin-bottom: 5px">
                    <div class="card-upcoming-class m-3" style="gap: 4px">
                      <label class="custom-user-subtitle" style="color: #ffffff; margin-bottom: 0rem">
                      </label>
                      <label class="custom-user-subtitle" style="color: #ffffff; margin-bottom: 0rem"> 
                        No Data
                      </label>
                    </div>
                  </CCard>
                </div>
              </CRow>
            </CCard> -->
  
           
            <!-- popup click class -->
            <div v-if="this.DetailClass == true">
              <div v-for="item in classes" v-bind:key="item.Id">
                <div v-if="item.id == selectedSchedule">
                <br />
                  <CCard style="
                    position: fixed;
                    bottom: 0px;
                    margin:0 auto;
                    left:0;
                    right:0;
                    width: -webkit-fill-available;
                    height:auto;"
                  >
                    <span style="width: 15%" class="float-right" @click="CloseDetail">
                      <h6><strong>X</strong></h6>
                    </span>
                    <br />
                    <CRow class="ml-2 mr-2">
                      <div style="width: 25%" class="float-left">
                        <h6 class="ml-2"><strong>Student</strong></h6>
                      </div>
                      <div style="width: 75%" class="float-right">
                        :
                        <span v-for="name in item.student" v-bind:key="name.id">
                          {{ name.studentName }} ,
                        </span>
                      </div>
                      <div style="clear: both"></div>
                    </CRow>
  
                    <!-- <div v-if="this.todayButton == true"> -->
                    <CRow class="justify-content-center mt-3">
                      <CCol style="display: flex; align-items: center; justify-content: center;">
                        <CCol sm="12" lg="12">
                          <div v-if="item.start <= item.currentDate">
                            <!-- <label>TRY TRUE</label> -->
                            <CCol
                              sm="12"
                              lg="12"
                              style="
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                left: 0;
                                right: 0;
                                bottom: 0px;
                              "
                            >
                              <CCol sm="3" lg="3" class="p-0 mr-2" style="width: 25%">
                                <CCard style="border: none" class="text-center p-1" @click="GoToManage(item.id)">
                                  <CCol>
                                    <img src="../../assets/img/icon/reschedule.svg" />
                                    <br />
                                    <label class="text-icon custom-font-card"> Manage </label>
                                  </CCol>
                                </CCard>
                              </CCol>
  
                              <CCol sm="3" lg="3" class="p-0 mr-2" style="width: 25%">
                                <CCard style="border: none" class="text-center p-1" @click="GoToAttendance(item.id)">
                                  <CCol>
                                    <img src="../../assets/img/icon/classAttendance.svg" />
                                    <br />
                                    <label class="text-icon custom-font-card"> Attendance </label>
                                  </CCol>
                                </CCard>
                              </CCol>
                            </CCol>
                          </div>
  
                          <div v-else>
                            <CCol sm="12" lg="12"
                              style="
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                left: 0;
                                right: 0;
                                bottom: 0px;
                              "
                            >
                              <CCol sm="3" lg="3" class="p-0 mr-2" style="width: 25%">
                                <!-- <span v-for="name in item.student" v-bind:key="name.id"> -->
                                  <CCard style="border: none" class="text-center p-1" @click="GoToManage(item.id)">
                                    <CCol>
                                      <img src="../../assets/img/icon/reschedule.svg" />
                                      <br />
                                      <label class="text-icon custom-font-card"> Manage </label>
                                    </CCol>
                                  </CCard>
                                <!-- </span> -->
                              </CCol>
  
                              <CCol sm="3" lg="3" class="p-0 mr-2" style="width: 25%">
                                <CCard style="border: none" class="text-center p-1" >
                                  <CCol>
                                    <img src="../../assets/img/icon/classAttendance.svg" style="filter: grayscale(1);"/>
                                    <br />
                                    <label class="text-icon custom-font-card"> Attendance </label>
                                  </CCol>
                                </CCard>
                              </CCol>
                            </CCol>
                          </div>

                        </CCol>
                      </CCol>
                    </CRow>
                  <!-- </div> -->
                  </CCard>
                </div>
              </div>
                  
              </div>
          </div>
        </div>
      </CContainer>
    </div>
  </template>
  
  <script>
  import Vue from "vue";
  Vue.use(require("vue-moment"));
  import moment from "moment";
  import DatePick from "vue-date-pick";
  import "vue-date-pick/dist/vueDatePick.css";
  export default {
    components: { DatePick },
    data: () => ({
      date: "",
    }),
    data: function () {
      return {
        user: {},
        classes: [],
        DetailClass: false,
        detailSchedule: [],
        // today: new Date().toLocaleString(),
        dateButton: false,
        todayButton: false,
      };
    },
    async mounted() {
      let isAuth = await this.UserAuth();
  
      if (isAuth) {
        this.Busy = false;
        this.GetInfoUser();
      } else {
        this.GoToLogin();
      }
    },
  
    methods: {
     
      GetInfoUser() {
        return this.$API
          .get(this.$LoginUserDetailWebs, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200) {
              this.user = response.data;
              this.GetTimeTableTeacher(this.user.id);
            }
          });
      },
      GetTimeTableTeacher() {
        this.$API
          .get(this.$TeacherSchedule + "?id=" + this.user.id, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              this.classes = response.data;
            }
  
            for (let index = 0; index < this.classes.length; index++) {
              var element = this.classes[index];
  
                var date = element.start;
                var today = element.currentDate;
                console.log(date);
                console.log(today);
  
                if(date <= today) {
                  console.log("SHOW")
                  this.dateButton = true;
                }
                else if(date > today) { 
                  console.log("HIDE");
                  this.todayButton = true;
                }
            }
          });
      },
      CloseDetail()
      {
        this.DetailClass = false;
      },
      OpenDetail(ids) {
          this.selectedSchedule = ids;
          this.DetailClass = true;
  
      // return this.$API
      //     .get(this.$TeacherTimeTableByScheduleId + "?id=" + this.user.id + "&scheduleId=" + id, {
      //       withCredentials: true,
      //     })
      //     .then((response) => {
      //       if (response.status == 200) {
             
      //         this.detailSchedule = response.data;
             
      //       }
      //     });
      },
  
      GoToAttendance(id) {
        this.$router.push(
          "TutorScheduleAttendance?scheduleId=" + 
          id
        );
      },
  
      GoToManage(scheid) {
        this.$router.push(
          "TutorScheduleManage?scheduleId=" + 
          scheid
        );
      },
  
      // currentDate() {
      //   const current = new Date();
      //   const date = `${current.getDate()}/${current.getMonth()+1}/${current.getFullYear()}`;
      //   return date;
      // }
    },
  };
  </script>
  
  <style scoped>
  @import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
  
  input {
    border-bottom: 2px solid #dbdbdb;
    background: none;
    border-top: none;
    border-left: none;
    border-right: none;
    width: 90%;
  }
  
  input ::placeholder {
    color: #e0e0e0;
  }
  
  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #e0e0e0;
  }
  .c-app {
    background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  }
  .custom-bg-color {
    background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
    /* Clickable/Light */
  
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    margin: 0px 20px;
    display: flex;
    justify-content: center;
  }
  body {
    font-family: "Montserrat", sans-serif;
  }
  
  .class-teach-name {
    padding: 4px 1px;
    top: 45px;
    /* height: 40px; */
  
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
  
    /* Pure/White */
  
    color: #ffffff;
  
    /* Inside auto layout */
  
    /* flex: none;
    order: 0;
    flex-grow: 0; */
  }
  
  .background-timetable {
    background: #e8f4ff;
  }
  
  .bottom-timetable {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0px;
    gap: 83px;
  
    position: absolute;
    width: 320px;
    height: 24px;
    left: 28px;
    top: -7px;
  }
  
  .row-timetable {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 0px;
    /* gap: 24px; */
  
    /* width: 335px; */
    /* height: 148px; */
  
    margin: 0px 20px;
    display: flex;
    /* justify-content: center; */
  
    /* Inside auto layout */
  
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
  }
  
  .badge-label-subject {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 150%;
    /* identical to box height, or 18px */
  
    /* Black/Dark-001 */
  
    color: #000a2c;
  }
  
  .card-timetable {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 12px 8px;
    gap: 10px;
  
    /* width: 279px; */
    height: 70px;
  
    /* Blue/Dark */
  
    border-radius: 8px;
  }
  
  .date-timetable {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
  }
  </style>